<div *ngIf="loading; else messageEditor" class="tw-flex tw-flex-col tw-items-center tw-w-full tw-pr-2">
    <mat-progress-spinner  [color]="'primary'" [diameter]="50" mode="indeterminate" ></mat-progress-spinner>
    <div class="tw-mt-8 tw-pb-3.5">Loading Email Templates</div>
</div>
<ng-template #messageEditor>
    <div class="message-create-editor" appDragonDrop (FileDropped)="uploadFile($event)" *ngIf="signature && (templates$ | async)">
        <app-alert *ngIf="documentAlert"
            [level]="documentAlert.level"
            [message]="documentAlert.message"
            (dismissed)="dismissDocumentAlert()"
        >
        </app-alert>
        <div *ngIf="unknownContactAlert.length > 0">
            <app-email-alert *ngFor="let uca of unknownContactAlert, let index = index"
                [level]="uca.level"
                [message]="uca.message"
                [emailAddress]="uca.emailAddress"
                [borrowerId]="borrower.id"
                (dismissed)="dismissUnknownContactAlert(index)"
            >
            </app-email-alert>
        </div>
        <form [formGroup]="emailForm">
            <mat-form-field class="message-create-emails" floatLabel="never">
                <span matPrefix class="tw-px-2">To: &nbsp;</span>
                <mat-chip-grid #toChipList class="tw-place-items-start">
                    <button
                        class="add-recipient-button"
                        [matMenuTriggerFor]="add"
                        color="primary"
                        mat-stroked-button
                        data-cy="email-add-contact">
                            Add
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #add="matMenu" class="add-email-menu">
                        <app-recipient-menu
                            [joinedContacts]="joinedContacts"
                            [lendioEmailDirectory]="lendioEmailDirectory$ | async"
                            [borrowerId]="borrower.id"
                            [recipientType]="'to'"
                            (addRecipient)="addRecipient($event)"
                            (launchAddNewContactModal)="launchAddNewContactModal($event)"
                            (addLendioRecipient)="addLendioRecipient($event)">
                        </app-recipient-menu>
                    </mat-menu>
                    <div *ngFor="let recipient of toEmailControl">
                        <app-email-recipient
                            [recipient]="recipient"
                            [recipientType]="'to'"
                            (removeRecipient)="removeRecipient($event)">
                        </app-email-recipient>
                    </div>
                  <input [matChipInputFor]="toChipList" [hidden]="true" />
                </mat-chip-grid>
                <span matSuffix *ngIf='!addBCC'>
                    <small class="tw-leading-5"><a data-cy="email-bcc-input" class="tw-font-semibold tw-pr-3 tw-cursor-pointer" (click)='showBCCRecipients(); populateBcc();'>BCC</a></small>
                </span>
            </mat-form-field>
            <mat-form-field class="message-create-emails" *ngIf='addBCC'>
                <div matPrefix class="tw-px-2">BCC: &nbsp;</div>
                <mat-chip-grid #bccChipList>
                    <button
                        class="add-recipient-button"
                        [matMenuTriggerFor]="add"
                        color="primary"
                        mat-stroked-button>
                            Add
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #add="matMenu" class="add-email-menu">
                        <app-recipient-menu
                            [joinedContacts]="joinedContacts"
                            [lendioEmailDirectory]="lendioEmailDirectory$ | async"
                            [borrowerId]="borrower.id"
                            [recipientType]="'bcc'"
                            (addBCCRecipient)="addBCCRecipient($event)"
                            (launchAddNewContactModal)="launchAddNewContactModal($event)"
                            (addLendioBCCRecipient)="addLendioBCCRecipient($event)">
                        </app-recipient-menu>
                    </mat-menu>
                    <div *ngFor="let recipient of bccEmailControl">
                        <app-email-recipient
                            [recipient]="recipient"
                            [recipientType]="'bcc'"
                            (removeRecipient)="removeRecipient($event)">
                        </app-email-recipient>
                    </div>
                  <input [matChipInputFor]="bccChipList" [hidden]="true" />
                </mat-chip-grid>
            </mat-form-field>
            <mat-form-field *ngIf="showSubjectField" class="message-create-emails" #matFormFieldSubject>
                <div matPrefix data-cy="email-subject-input" class="tw-pl-2.5">Subject: &nbsp;</div>
                <input matInput formControlName="subject">
            </mat-form-field>
        </form>
        <div class="message-create-quill">
            <quill-editor class="tw-mt-4" [placeholder]='placeholder' format="html" [(ngModel)]="content" (onEditorCreated)="handleEditorCreated($event)" (onSelectionChanged)="handleSelectionChange($event.range)" (onContentChanged)="handleContentChange()" (keydown.enter)="handleEnterSelectionLocation()">
              <!--- quill-editor adds an ::after element after the toolbar --->
              <div quill-editor-toolbar class="tw-mt-4 column-grid tw-grid-cols-[1fr_auto_0] tw-place-items-center">
                    <div class="column-grid tw-gap-2 tw-justify-self-start tw-place-items-center">
                        <button mat-button matTooltip="Bold Text" class="ql-bold !tw-min-w-fit"></button>
                        <button mat-button matTooltip="Italic Text" class="ql-italic !tw-min-w-fit"></button>
                        <button mat-button matTooltip="Ordered List" class="ql-list !tw-min-w-fit" value="ordered"></button>
                        <button mat-button matTooltip="Bullet List" class="ql-list !tw-min-w-fit" value="bullet"></button>

                        <button mat-icon-button
                                [disableRipple]="true"
                                data-cy="email-attachment-btn"
                                class="!tw-min-w-fit !tw-p-0"
                                [matMenuTriggerFor]="attachmentHandler"
                                matTooltip="Add Attachment">
                            <mat-icon>attachment</mat-icon>
                            <mat-menu #attachmentHandler>
                                <button class="link-list" mat-menu-item
                                    (click)="fileInput.click()">
                                    <a class="link-list-items">Computer</a>
                                </button>
                                <input #fileInput
                                    type="file"
                                    (change)="uploadDocuments($event.target.files)"
                                    style="display:none;"
                                    multiple/>
                                <button class="link-list link-list-items" mat-menu-item>
                                    <app-document-picker
                                        [borrower]="borrower"
                                        (selectedFile)="onFileChange($event)">
                                    </app-document-picker>
                                </button>
                            </mat-menu>
                        </button>

                        <button style="display: none;" mat-button id="message-add-emoji" [matMenuTriggerFor]="emojiMart" matTooltip="Pick your emoji...">
                            <i class="fa fa-lg fa-smile-o message-emoji-icon"></i>
                            <mat-menu class="message-emoji-mart-mat-menu" #emojiMart>
                                <emoji-mart emoji="point_up" title="Pick your emoji..." (click)="$event.stopPropagation()" (emojiClick)="handleEmoji($event)"></emoji-mart>
                            </mat-menu>
                        </button>

                        <app-template-picker *ngIf="(templates$ | async) && (opportunity$ | async) as opportunity"
                            [affiliateId]='opportunity?.marketing?.affiliateId'
                            [templates]='templates$ | async'
                            [selectedTemplate]='selectedTemplate'
                            (chooseTemplate)="chooseTemplate($event)">
                        </app-template-picker>

                        <button mat-button
                                class="tw-whitespace-nowrap !tw-w-fit"
                                data-cy="email-template-btn"
                                id="add-message-link"
                                [matMenuTriggerFor]="linkHandler"
                                (click)="getLinks()">
                            <span class="message-insert-link-text">Add Link</span>
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>

                        <mat-menu #linkHandler>
                            <button class="link-list" mat-menu-item *ngFor="let link of links">
                                <a class="link-list-items tw-text-black" (click)="handleInsertLink(link)">{{ link.label }}</a>
                            </button>
                        </mat-menu>
                    </div>
                  <div class="column-grid tw-gap-2 tw-justify-self-end">
                    <button
                      mat-button
                      [color]="'primary'"
                      (click)="previewMessage()">
                      Preview
                    </button>
                    <button mat-button (click)="handleCancelMessage()" data-cy="email-cancel-btn">Cancel</button>
                    <button
                      *ngIf="!messageType && content"
                      mat-raised-button
                      [ngClass]="{'send-message-truthy': content && content.trim().length && !sendButtonDisabled && content.trim().length && toEmailControl.length && changeCount > 1}"
                      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || changeCount < 1"
                      (click)="sendMessage()"
                      data-cy="email-send-btn"
                      id="send-key-command"
                    >Send</button>
                    <button
                      *ngIf="messageType === 'reply' && content"
                      mat-raised-button
                      class="message-create-send"
                      [ngClass]="{'send-message-truthy': content && content.trim().length && !sendButtonDisabled && content.trim().length && toEmailControl.length && changeCount > 1}"
                      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || changeCount < 1"
                      (click)="sendMessage()"
                      data-cy="email-reply-btn"
                      id="send-key-command"
                    >Reply</button>
                    <button
                      *ngIf="messageType === 'forward' && content"
                      mat-raised-button
                      class="message-create-forward"
                      [ngClass]="{'send-message-truthy': content && content.trim().length && !sendButtonDisabled && content.trim().length && toEmailControl.length && changeCount > 1}"
                      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || changeCount < 1"
                      (click)="sendMessage()"
                      id="send-key-command"
                    >Forward</button>
                  </div>
                </div>
            </quill-editor>
            <mat-progress-bar *ngIf="files.length" mode="indeterminate"></mat-progress-bar>
            <div *ngIf="documents.length || files.length">
                <mat-chip-listbox>
                    <mat-chip class="message-attachments" *ngFor="let document of documents; let i = index">
                        {{ document.title }}
                        {{ document.size | bytes }}
                        <mat-icon matChipRemove (click)="documents.splice(i, 1)">cancel</mat-icon>
                    </mat-chip>
                    <mat-chip class="message-attachments" *ngFor="let file of files">
                        {{ file.name }}
                    </mat-chip>
                    <span class="dropItRealGood">Drop File</span>
                </mat-chip-listbox>
            </div>
            <span *ngIf="!(documents.length || files.length)" class="dropItRealGood">Drop File</span>
        </div>
    </div>
</ng-template>
